/*
 * 路由模块集合
 * */
import login from './routes/login';
import exception from './routes/exception';
import home from '@/router/routes/home'
import admin from '@/router/routes/admin'
import businessManagement from '@/router/routes/businessManagement'
import jobLevel from '@/router/routes/jobLevel'
import customKeyPage from '@/router/routes/customKeyPage'
import helpPage from '@/router/routes/helpPage'
import mine from '@/router/routes/mine'
import taskSuper from '@/router/routes/taskSuper'
import testCom from '@/router/routes/testCom'
export default [
  {
    name: 'app', // 路由 name
    path: '/',
    redirect: "/main",
    meta: {
      title: '首页',
      name: '首页',
      href: '',
      isTab: false
    },
    component: () => import('@/layouts/app'),
    children: [
      ...home,
      ...admin,
      ...businessManagement,
      ...jobLevel,
      ...mine,
      ...customKeyPage,
      ...taskSuper,
      ...helpPage,
    ],
  },
  ...login,
  ...testCom,
  // 例外路由必须置于底部
  ...exception
];
